"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoList = void 0;
exports.hasVideoList = hasVideoList;
var player_1 = __importDefault(require("@vimeo/player"));
var youtube_player_1 = __importDefault(require("youtube-player"));
var config_1 = require("../config");
var get_closest_1 = require("../helper/get-closest");
var VideoList = /*#__PURE__*/function () {
  function VideoList() {
    _classCallCheck(this, VideoList);
    this.videoList = null;
    this.loadPlayer = this.loadPlayer.bind(this);
    this.handleThumbnailClick = this.handleThumbnailClick.bind(this);
    this.videoList = document.querySelectorAll(config_1.CONFIG.videoList.main);
    console.log('VideoList', this.videoList);
    Array.from(this.videoList).forEach(this.loadPlayer);
  }
  return _createClass(VideoList, [{
    key: "handleThumbnailClick",
    value: function handleThumbnailClick(thumbnailElement, playerWrapperElement) {
      thumbnailElement.parentElement.querySelector('.' + config_1.CONFIG.videoList.selectedClass).classList.remove(config_1.CONFIG.videoList.selectedClass);
      thumbnailElement.classList.add(config_1.CONFIG.videoList.selectedClass);
      var videoPlayerInner = playerWrapperElement.querySelector('.video-player-inner');
      videoPlayerInner.innerHTML = "<div data-hook=\"video-player\"></div>";
      var playerElement = playerWrapperElement.querySelector(config_1.CONFIG.videoList.player);
      switch (thumbnailElement.dataset.type) {
        case 'youtube':
          var player = (0, youtube_player_1["default"])(playerElement, {
            playerVars: {
              rel: 0
            }
          });
          player.loadVideoById(thumbnailElement.dataset.id);
          break;
        case 'vimeo':
          var newplayer = new player_1["default"](playerElement, {
            id: Number(thumbnailElement.dataset.id)
          });
          newplayer.play();
          break;
        default:
          break;
      }
      playerWrapperElement.querySelector(config_1.CONFIG.videoList.playerTitle).innerHTML = thumbnailElement.dataset.title;
      playerWrapperElement.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      });
    }
  }, {
    key: "loadPlayer",
    value: function loadPlayer(element) {
      var _this = this;
      var playerElement = element.querySelector(config_1.CONFIG.videoList.player);
      console.log('loadPlayer', playerElement);
      if (playerElement) {
        var playerWrapperElement = (0, get_closest_1.getClosest)(config_1.CONFIG.videoList.videoWrapper, playerElement);
        var videos = element.querySelectorAll(config_1.CONFIG.videoList.thumbnail);
        switch (playerElement.dataset.type) {
          case 'youtube':
            var youtubeplayer = (0, youtube_player_1["default"])(playerElement, {
              playerVars: {
                rel: 0
              }
            });
            playerElement.classList.add(config_1.CONFIG.videoList.selectedClass);
            youtubeplayer.cueVideoById(playerElement.dataset.id);
            break;
          case 'vimeo':
            var vimeoplayer = new player_1["default"](playerElement, {
              id: Number(playerElement.dataset.id)
            });
            vimeoplayer.pause();
            break;
          default:
            break;
        }
        Array.from(videos).forEach(function (thumbnail) {
          var thumbnailElement = (0, get_closest_1.getClosest)(config_1.CONFIG.videoList.thumbnail, thumbnail);
          thumbnailElement.addEventListener('click', function () {
            return _this.handleThumbnailClick(thumbnailElement, playerWrapperElement);
          });
        });
      } else {
        console.error('Check you have a player for each video');
      }
    }
  }]);
}();
exports.VideoList = VideoList;
function hasVideoList() {
  if (document.querySelectorAll(config_1.CONFIG.videoList.main).length > 0) {
    return true;
  }
  return false;
}